export default "__VITE_ASSET__BfW0rQJX__"